module.exports = __webpack_public_path__ + "img/con4.cf780be8.png";